<div class="nav-rail-container">
  <ng-content></ng-content>
</div>
